import(/* webpackMode: "eager" */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/src/components/ui/CountUpNumber.tsx");
;
import(/* webpackMode: "eager" */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/src/components/ui/LogoSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/u983891880/domains/military.thepurpleoctopus.in/hbuilds/source/pov-main/src/components/ui/ScrollReveal.tsx");
